var _rect, _g, _rect2, _path, _g2, _g3, _rect3, _rect4, _line, _line2, _line3, _path2, _path3, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgActivateAudience = function SvgActivateAudience(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 125,
    viewBox: "0 0 205 125",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 1,
    width: 122,
    height: 122,
    rx: 9,
    fill: "#232323",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4009)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 132,
    height: 28,
    rx: 4,
    fill: "#343434"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#C1C1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9478 25.808H23.7398C23.7538 24.436 26.2738 23.988 26.2738 21.804C26.2738 20.194 24.9018 19.004 22.9698 19.004C20.8978 19.004 19.7218 20.376 19.4978 21.874L21.1778 22.378C21.4018 21.412 22.0178 20.712 22.9558 20.712C23.8238 20.712 24.3558 21.202 24.3558 21.902C24.3558 23.246 21.9618 23.68 21.9478 25.808ZM22.8438 29.112C23.4738 29.112 23.9778 28.608 23.9778 27.964C23.9778 27.362 23.4738 26.872 22.8438 26.872C22.1998 26.872 21.6958 27.362 21.6958 27.964C21.6958 28.608 22.1998 29.112 22.8438 29.112Z",
    fill: "#343434"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_4009)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 48,
    width: 132,
    height: 28,
    rx: 4,
    fill: "#343434"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_4009)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 86,
    width: 132,
    height: 28,
    rx: 4,
    fill: "#343434"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 51,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#C1C1C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 89,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#C1C1C1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 61.5,
    y1: 99.5,
    x2: 133.5,
    y2: 99.5,
    stroke: "#E2E8F0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100.5,
    y1: 61.5,
    x2: 172.5,
    y2: 61.5,
    stroke: "#E2E8F0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 43.5,
    y1: 23.5,
    x2: 115.5,
    y2: 23.5,
    stroke: "#E2E8F0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9478 63.808H78.7398C78.7538 62.436 81.2738 61.988 81.2738 59.804C81.2738 58.194 79.9018 57.004 77.9698 57.004C75.8978 57.004 74.7218 58.376 74.4978 59.874L76.1778 60.378C76.4018 59.412 77.0178 58.712 77.9558 58.712C78.8238 58.712 79.3558 59.202 79.3558 59.902C79.3558 61.246 76.9618 61.68 76.9478 63.808ZM77.8438 67.112C78.4738 67.112 78.9778 66.608 78.9778 65.964C78.9778 65.362 78.4738 64.872 77.8438 64.872C77.1998 64.872 76.6958 65.362 76.6958 65.964C76.6958 66.608 77.1998 67.112 77.8438 67.112Z",
    fill: "#343434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9478 101.808H40.7398C40.7538 100.436 43.2738 99.988 43.2738 97.804C43.2738 96.194 41.9018 95.004 39.9698 95.004C37.8978 95.004 36.7218 96.376 36.4978 97.874L38.1778 98.378C38.4018 97.412 39.0178 96.712 39.9558 96.712C40.8238 96.712 41.3558 97.202 41.3558 97.902C41.3558 99.246 38.9618 99.68 38.9478 101.808ZM39.8438 105.112C40.4738 105.112 40.9778 104.608 40.9778 103.964C40.9778 103.362 40.4738 102.872 39.8438 102.872C39.1998 102.872 38.6958 103.362 38.6958 103.964C38.6958 104.608 39.1998 105.112 39.8438 105.112Z",
    fill: "#343434"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4009",
    x: 0,
    y: 3,
    width: 150,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_4009"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_4009",
    x: 55,
    y: 41,
    width: 150,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_4009"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_4009",
    x: 17,
    y: 79,
    width: 150,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_4009"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4009",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActivateAudience, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/activate_audience.17a0c64e.svg";
export { ForwardRef as ReactComponent };